{
  "StatvaluestypeLabel": "Uitvoer voor velden Percentage, Datum\/Tijd & Duur:",
  "StatvaluestypeBothOptionLabel": "[Dubbele waarden (opgemaakt + onbewerkt)]",
  "StatvaluestypeMainOptionLabel": "Valutaweergave-indeling",
  "StatvaluestypeAlternateOptionLabel": "Help weergeven voor gebruikers die bulksgewijs uploaden.",
  "CSVExportFormat_SectionHeader": "CSV-exportformaat",
  "CSVExportFormat_SectionPara": "U kunt aanpassen hoe percentage, datum\/tijd en duurstatistieken worden gegenereerd in geëxporteerde CSV-rapporten.",
  "NAME": "CSVExportFormat"
}